import { Injectable } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {ConfirmDialogComponent, ErrorDialogComponent} from '../../shared/components/dialogs';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<ConfirmDialogComponent>;
  errDialogRef: MatDialogRef<ErrorDialogComponent>;

  public open(options) {
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: options.title,
        message: options.message,
        cancelText: options.cancelText,
        confirmText: options.confirmText
      }
    });
  }

  public confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
        return res;
      }
    ));
  }

  public openError(message) {
    this.errDialogRef = this.dialog.open(ErrorDialogComponent, {
      data: message
    });
  }
}
